import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { ArrowCircleUp } from '../../../../../icons/arrow-circle-up';
import STRING_KEYS from '../../../../../language/keys';
import { style } from './style';

export const CandidatePromoteStateFetching = (): JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Box sx={ style.Box.sx }>
      <ArrowCircleUp color="primary" />
      <Typography variant="body1" color="primary" sx={ style.Typography.sx }>
        {translate(STRING_KEYS.PROMOTING)}...
      </Typography>
    </Box>
  );
};
